const map = {
	"./2.mp4": 89071,
	"./Notification Center 1.png": 42691,
	"./Tax Management 1.png": 49273,
	"./australia.png": 10524,
	"./bangladesh.png": 68747,
	"./canada.png": 22134,
	"./content.png": 91089,
	"./slide1.png": 64456,
	"./slide2.png": 1315,
	"./slide3.png": 53562,
	"./slide4.png": 77333,
	"./slide5.png": 41420,
	"./slide5_old (1).png": 39020,
	"./slide5_old (2).png": 42185,
	"./slide5_old (3).png": 46338,
	"./slide5_old (4).png": 69279,
	"./slide5_old (5).png": 96696,
	"./uae.png": 68081,
	"./uk.png": 28804,
	"./usa.png": 71807
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90170;